import { render, staticRenderFns } from "./lainnya.vue?vue&type=template&id=4f2089ec&scoped=true&"
import script from "./lainnya.vue?vue&type=script&lang=js&"
export * from "./lainnya.vue?vue&type=script&lang=js&"
import style0 from "./lainnya.vue?vue&type=style&index=0&id=4f2089ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2089ec",
  null
  
)

export default component.exports